import React from 'react'
import 'aframe';
import 'aframe-particle-system-component';
import 'aframe-mouse-cursor-component'
import 'aframe-touch-look-controls'
import {Entity, Scene, Cursor, Camera} from 'aframe-react'

import test from './../UI/test.webp'

import Circulito from './../UI/viewer/circulitoWhite.png'
import CirculitoFamilia from './../UI/viewer/circulito.png'
import CirculitoIndividual from './../UI/viewer/circulitoIndividual.png'
import CiruclitoOrange from './../UI/viewer/circulitoKTM.png'
import CirculitoOrangeTest from './../UI/viewer/circulitoKTTest.png'
import transparent from './../UI/viewer/transparent.png'

import { recorridoData as RData} from '../data/recorrido.data';

class Viewer360 extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            zoom: 80,
            zoomValue: 0,
            isTouchScreen: false,
            fade: false,
            opacity: 1,
            planeOpacity: -1
        }
    }

    componentDidMount(){
        var filling = false
        setInterval(() => {
            if(this.state.opacity - (0.25 / 3) <= 1 && this.state.opacity - (0.25 / 3) >= 0.5 && !filling){
                this.setState({
                    opacity: this.state.opacity - (0.25 / 3)
                }, () => {
                    if(this.state.opacity - (0.25 / 3) < 0.5){
                        filling = true
                    }
                })
            }
            else if(this.state.opacity + (0.25 / 3) >= 0.5 && this.state.opacity + (0.25 / 3) <= 1 && filling){
                this.setState({
                    opacity: this.state.opacity + (0.25 / 3)
                }, () => {
                    if(this.state.opacity + (0.25 / 3) > 1){
                        filling = false
                    }
                })
            }
        }, 125)
    }

    handleZoom = (event) => {

        var rotation = document.querySelector('a-scene').camera.el.object3D;

        var value = event.deltaY < 0 ? -1.5 : 1.5
        this.setState({
            zoomValue: this.state.zoomValue + value
        }, () => {
            this.state.zoomValue < -30 ? this.setState({
                zoomValue: -30
            }):
            this.state.zoomValue > 10 ? this.setState({
                zoomValue: 10
            }):
            this.setState({
                zoom: this.state.zoom + value
            })
        })
    }

    handleTouchScreen = (event) => {
        this.setState({
            isTouchScreen: true
        })
    }

    handleMouse = () => {
        this.setState({
            isTouchScreen: false
        })
    }

    componentDidUpdate = (prevProps) => {
        if(prevProps.currentScene.Image.default !== this.props.currentScene.Image.default){
            this.setState({
                fade: true
            })
            new Promise((resolve, reject) => {
                const img = new Image()
                img.src = this.props.currentScene.Image.default
                img.onload = (event) => {
                    this.setState({
                        fade: false
                    })
                }
            })
        }
    }

    handleLoad = (payload) => {
        this.setState({
            fade: true
        })

        console.log(payload)
        console.log(RData()[0])

        new Promise((resolve, reject) => {
            const img = new Image()
            img.src = RData()[0][payload].Image.default
            img.onload = (event) => {
                this.setState({
                    fade: false
                }, () => {
                    if(!this.state.fade){
                        this.props.handlePanoUpdate(payload)
                    }
                })
            }
        })
    }

    handleCreateBullet = (payload) => {
        var bullets = payload.Bullets
        return(
            bullets.map((bullets, index) => 
                        <Entity 
                            key={index}
                            geometry={{primitive: "circle", radius: this.state.opacity}}
                            cursor-listener 
                            class="raycastable" 
                            position={bullets.Position}
                            rotation={bullets.Rotation}
                            transparent="true"
                            scale={bullets.Scale}
                            src = {Circulito}
                            material={{color:"", transparent: true, src : Circulito, opacity: this.state.opacity}}
                            events={{click: () => this.handleLoad(bullets.goTo), mouseenter: () => {}}}
                        />
        )
        )
    }

    handleCreateBulletFamilia = (payload) => {
        var bullets = payload.BulletsFamilia
        return(
            bullets.map((bullets, index) => 
                        <Entity 
                            key={index}
                            geometry={{primitive: "circle", radius: this.state.opacity}}
                            cursor-listener 
                            class="raycastable" 
                            position={bullets.Position}
                            rotation={bullets.Rotation}
                            transparent="true"
                            scale={bullets.Scale}
                            src = {CirculitoFamilia}
                            material={{color:"", transparent: true, src : CirculitoFamilia, opacity: this.state.opacity}}
                            events={{click: () => this.handleLoad(bullets.goTo),  mouseenter: () => {}}}
                        />
        )
        )
    }

    handleCreateBulletIndividual = (payload) => {
        var bullets = payload.BulletsIndividuales
        return(
            bullets.map((bullets, index) => 
                        <Entity 
                            key={index}
                            geometry={{primitive: "circle", radius: this.state.opacity}}
                            cursor-listener 
                            class="raycastable" 
                            position={bullets.Position}
                            rotation={bullets.Rotation}
                            transparent="true"
                            scale={bullets.Scale}
                            src = {CirculitoIndividual}
                            material={{color:"", transparent: true, src : CirculitoIndividual, opacity: this.state.opacity}}
                            events={{click: () => this.handleLoad(bullets.goTo),  mouseenter: () => {}}}
                        />
        )
        )
    }

    handleCreateBulletInfo = (payload) => {
        var bullets = payload.BulletsInfo
        if(bullets && bullets.length >= 1 ){
            return(
                bullets.map((bullets, index) => 
                            <Entity 
                                key={index}
                                geometry={{primitive: "circle", radius: this.state.opacity}}
                                cursor-listener 
                                class="raycastable" 
                                position={bullets.Position}
                                rotation={bullets.Rotation}
                                transparent="true"
                                scale={bullets.Scale}
                                src = {CirculitoOrangeTest}
                                material={{color:"", transparent: true, src : CirculitoOrangeTest, opacity: this.state.opacity, shader: "flat", blending: "normal",fog: false}}
                                events={{click: () => this.props.handleOpenBullet(bullets.Image, bullets.Text)}}
                            />
            )
            )
        }
    }

    handleCreateLabels = (payload) => {
        var bullets = payload.Labels
        if(bullets && bullets.length >= 1 ){
            return(
                bullets.map((bullets, index) => 
                            <Entity 
                                key={index}
                                geometry="primitive: plane" 
                                cursor-listener 
                                class="raycastable" 
                                position={bullets.Position}
                                rotation={bullets.Rotation}
                                transparent="true"
                                scale={bullets.Scale}
                                src = {bullets.Image}
                                material={{color:"", transparent: true, src : bullets.Image, side:"double", opacity: this.state.planeOpacity === index ? 1:0}}
                                events={{click: () => {this.setState({planeOpacity: -1} , () => {this.props.handlePanoUpdate(bullets.goTo)})}}}
                            />
            )
            )
        }
    }

    handlePlaneOpacity = (payload) => {
        this.setState({
            planeOpacity: payload
        })
    }

    handleCreateLabelsPlanes = (payload) => {
        var bullets = payload.LabelsPlane
        if(bullets && bullets.length >= 1 ){
            return(
                bullets.map((bullets, index) => 
                            <Entity 
                                key={index}
                                geometry="primitive: plane" 
                                cursor-listener 
                                class="raycastable" 
                                position={bullets.Position}
                                rotation={bullets.Rotation}
                                transparent="true"
                                scale={bullets.Scale}
                                src = {bullets.Image}
                                material={{color: "", transparent: true, src : transparent, side:"double", opacity: 0.5}}
                                events={{
                                    mouseenter: () => {this.handlePlaneOpacity(index)}, 
                                    mouseleave: () => {this.handlePlaneOpacity(-1)}, 
                                    click: () => {this.setState({planeOpacity: -1} , () => {this.props.handlePanoUpdate(bullets.goTo)})}
                                }}
                            />
            )
            )
        }
    }


    render(){
        return(
            <React.Fragment>
                <div className={this.state.fade ? 'viewer-360':'viewer-360'} onWheel={(e) => {this.handleZoom(e)}} onTouchStart={(e) => {this.handleTouchScreen(e)}}>
                {
                    <Scene cursor="rayOrigin: mouse; fuse: false" raycaster="objects: .raycastable">
                        <Entity ref={this.camera} rotation={this.props.currentScene.Rotation} >
                        {
                            !this.state.isTouchScreen ?
                            <a-camera id="camera" fov={this.state.zoom} wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"  look-controls="reverseMouseDrag: true; reverseTouchDrag: true" aframe-injected="" data-aframe-inspector-original-camera=""/>:
                            <a-camera  id="camera" fov={this.state.zoom}  wasd-controls="adEnabled: false; enabled: false; wsEnabled: false"  aframe-injected="" data-aframe-inspector-original-camera="" camera="" touch-look-controls="reverseMouseDrag: true; reverseTouchDrag: true"></a-camera>
                        }
                        </Entity>
                        <Entity primitive='a-sky' src={this.props.currentScene.Image.default } segments-height={100} segments-width={200} radius={200}  />
                        {
                            this.handleCreateBullet(this.props.currentScene)
                        }
                        {
                            this.handleCreateBulletFamilia(this.props.currentScene)
                        }
                        {
                            this.handleCreateBulletIndividual(this.props.currentScene)
                        }
                        {
                            this.handleCreateBulletInfo(this.props.currentScene)
                        }
                        {
                            this.handleCreateLabels(this.props.currentScene)
                        }
                        {
                            this.handleCreateLabelsPlanes(this.props.currentScene)
                        }
                    </Scene>
                }
            </div>
            {
                <div className={this.state.fade ? "loading-div fade-in":"loading-div fade-out"} 
                    style={{
                        backgroundColor: "rgba(0,0,0,0.6)", 
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        top: "0"
                        }}>
                    <svg className="loader-circle" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                        <circle className= 'internal-circle' cx="75" cy="75" r="70"></circle>
                    </svg>
                    <svg className="loader-circle-over" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                        <circle className= 'internal-circle-over' cx="75" cy="75" r="70"></circle>
                    </svg>
                </div>
            }
            </React.Fragment>
        )
    }
}

export default Viewer360